import {Component, OnInit, ViewChild} from '@angular/core';
import {LocalStorageService} from 'ng2-webstorage';
import {MessageService} from 'primeng/components/common/messageservice';
import {ConfirmationService, Paginator} from 'primeng/primeng';
import {ParentChildService} from '../../../../../components/parentchild/parentchild.service';
import {DataAnalyticsService} from '../../../../../components/dataAnalytics/dataAnalytics.service';
import {Router} from '@angular/router';
import {UserService} from '../../../../../components/manageuser/user/user.service';
import {AddUserFirebaseService} from '../../../../../components/manageuser/adduser/adduserfirebase.service';
import {SectionModel} from '../../../../../components/manageuser/sections/sections.model';
import {SectionService} from '../../../../../components/manageuser/sections/sections.service';
import {NoticeboardService} from '../../../../../components/noticeboard/noticeboard/noticeboard.service';

@Component({
  selector: 'app-student-profile',
  templateUrl: './manage-user-groups.component.html',
  styleUrls: ['./manage-user-groups.component.css']
})

export class ManageUserGroupsComponent implements OnInit {
  // public addpop: boolean = false;
  display = "none"
  public data: any;
  public spinnershow: boolean = false;

  public maxSize: number = 10;
  public bigCurrentPage: number = 1;
  public bigTotalItems: number;

  public mappedData: any;
  public SelectedGrades = [];
  public SectionModel = new SectionModel();
  public standards: any;
  public newSectionArray = [];
  public base = [];
  public deleteId: any;
  public standardAllName:any;
  public searchString: any;
  public isEditFlag : boolean = false;

  constructor(private router: Router, private userService: UserService,
              private messageService: MessageService,
              private adduserfirebaseService: AddUserFirebaseService,
              private localStorage: LocalStorageService,
              private confirmationService: ConfirmationService,
              private SectionService: SectionService,
              private NoticeboardService: NoticeboardService) {
    this.SectionModel.Name = '';
    this.SectionModel.SchoolId = '';
    this.SectionModel.SchoolId = this.localStorage.retrieve('SchoolId');


  }
  ngOnInit() {
    // console.log(this.SelectedGrades,'selectedgrades')
    this.getAllSections(this.bigCurrentPage);
    this.NoticeboardService.getClassSectionMap().finally(() => { }).subscribe(response => {
        this.mappedData = response;
        this.standards = this.mappedData.map(o => {
          return {
            standardsName: o.standardsName,
            standardId: o.standardId,
            RoleId: '43943839-9469-40F4-8E5C-D4CA1A743806',
            SchoolId: this.SectionModel.SchoolId,
            selected: false
          };
        });
      },
      error => {
      })
  }
  gradeHead(e, grade) {
    //  console.log(grade,'stName');
    if (e.target.checked) {
      this.SelectedGrades.push({ StandardId: grade});
      console.log('SelectedGrades',this.SelectedGrades)
    }
    else {
      const index= this.SelectedGrades.indexOf(this.SelectedGrades.find(ele=> ele.StandardId == grade));
      this.SelectedGrades.splice(index, 1);
      console.log('index', index)
      // this.SelectedGrades = this.SelectedGrades.filter(ele => ele.standardId != grade.standardId)
      console.log('SelectedGrades1', this.SelectedGrades)
    }

  }
  //ADD
  postSection(form) {
    this.SectionModel['SelectedGrades'] = this.SelectedGrades;
    if (this.SelectedGrades.length > 0) {
      this.SectionService.postSection(this.SectionModel).finally(() => { }).subscribe(
        response => {
          // this.addpop = false;
          this.display = "none"
          this.messageService.add({ severity: 'success', summary: 'Talkative Parents', detail: 'Section added Successfully' });
          this.getAllSections(this.bigCurrentPage);
          // console.log('sel',this.SelectedGrades)

        },
        error => {
        })
    }
    else{
      this.messageService.add({ severity: 'error', summary: 'Talkative Parents', detail: 'Select atleast one grade' });
    }
  }
  //GET
  getAllSections(pagenum) {
    this.spinnershow = true;
    this.SectionService.getSections(pagenum, this.searchString).finally(() => { }).subscribe((response) => {
        this.bigTotalItems = (Number(response['TotalPages']) * this.maxSize);
        this.data = [];
        this.data = response['items'];
        this.data.forEach(element => {
          const gradeselected = element.SelectedGrades;
          function compare(a, b) {
            const bandA = a.StandardName;
            const bandB = b.StandardName;
            let comparison = 0;
            if (bandA > bandB) {
              comparison = 1;
            } else if (bandA < bandB) {
              comparison = -1;
            }
            return comparison;
          }
          gradeselected.sort(compare);
        });

        this.spinnershow = false;
        // this.newSectionArray = asEnumerable(this.data).GroupBy(
        //   x => x.name,
        //   x => x, (key, b) => {
        //     return {
        //       name: key,
        //       base: asEnumerable(b).ToArray()
        //     }
        //   }).ToArray();
        // this.newSectionArray.forEach(ele =>
        //   this.base.push(ele.base)
        // )

      }, error => {
      }
    )
    return this.SelectedGrades.sort((a, b) => a - b);
  }

  //DELETE
  confirm(classId) {
    this.confirmationService.confirm({
      message: 'Are you sure that you want to perform this action?',
      accept: () => {
        this.deleteSection(classId);

      }
    });
  }
  private deleteSection(classId) {
    var grades = classId['SelectedGrades']
    this.deleteId = grades[0].SectionalGradeId
    this.SectionService.DeleteSection(this.deleteId).finally(() => { }).subscribe(
      response => {
        var value = response['Value'];
        if (value == 'Cannot Delete, Sectional Grade in use!') {
          this.messageService.add({ severity: 'error', summary: 'Talkative Parents', detail: value });
        } else
        if (value == 'Successfully Deleted!') {
          this.messageService.add({ severity: 'success', summary: 'Talkative Parents', detail: value });

        }
        this.getAllSections(this.bigCurrentPage);
      },
      error => {

      });

  }
  //ADD POPUP
  addSection(type) {
    if (this.SectionModel["Id"] != undefined) {
      delete this.SectionModel["Id"]
    }
    // this.addpop = true;
    this.display = "block"
    this.SectionModel.Name = "";
    this.standards.forEach(ele => {
      ele['selected'] = false;
    })
    if (type == "add") {
      this.SectionModel['SelectedGrades'] = [];
      this.SelectedGrades = [];
    }
  }

  onCloseHandled() {
    this.display= "none";
  }

  //EDIT FUNCTIONALITY
  editSection(grade) {
    this.SelectedGrades = grade['SelectedGrades']
    this.isEditFlag = true;
    console.log(this.standards)
    this.standards.forEach(ele => {
      if (grade['SelectedGrades'].filter(w => w.StandardId == ele.standardId).length > 0) {
        ele['selected'] = true;
        this.SectionModel.Name = grade.Name;
      } else {
        ele['selected'] = false;
      }
      // this.SelectedGrades = grade['SelectedGrades'];
    });

    // this.addpop = true;
    this.display = "block"
    this.SectionModel['Id'] = grade.Id;
  }
  pageChanged(event) {
    this.getAllSections(event.page);
  }

  onSearchChange(searchString) {
    this.searchString = searchString;
    this.getAllSections(this.bigCurrentPage);
  }


}



// WEBPACK FOOTER //
// /builds/yaratechnologies/talkative-parents-portal/src/app/parent/dashboard/pages/manage-user/manage-user-groups/manage-user-groups.component.ts